// extracted by mini-css-extract-plugin
module.exports = {"uploadDocumentTab":"uploadDocumentTab__VErEM","dropArea":"dropArea__1Mmzy"};